
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePriceTierDtoFormGroup() {
return new FormGroup({
    itemId: new FormControl<number | undefined>(undefined),
    minQuantity: new FormControl<number | undefined>(undefined, [Validators.min(0)]),
    maxQuantity: new FormControl<number | undefined>(undefined, [Validators.min(0)]),
    discountPercentage: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    validFrom: new FormControl<string | undefined>(undefined),
    validTo: new FormControl<string | undefined>(undefined),
})
;
}
      